export default __webpack_public_path__ + "static/2-2bed54d62b5d3a681aa27485b5b867d6.webp";